import PopupModel from "../../shared/popupModel/popupModel";

const DvrVideoPlayer = ({handleShowVideoPlayer}) => {
    return(
        <PopupModel classes={'width-900'} showPopupModel={handleShowVideoPlayer}>
            <div className="icon width-block-100 margin-b-10">
                <img src={'https://fdrive.in/onboardFleet/driverImages/img1.png'} alt=""/>
            </div>
            <div className="font-14 flex">
                <div className="flex gap-15 sf-medium">
                    <div className="font-15"><span className={'margin-r-15'}>19:27</span> 15 Sep
                        2023
                    </div>
                </div>
                <ul className="separator gap-30 sf-bold">
                    <li>KA 02 N 9023</li>
                    <li>Driver: <span className={'blue-color'}>Babu K</span></li>
                </ul>
                <div className="grey-color sf-medium">Eicher/HMV Chennai - Ahmedabad</div>
            </div>
        </PopupModel>
    )
}

export default DvrVideoPlayer;
